export default "__VITE_ASSET__BLwiWSAL__"